import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";
import { styled } from "@twilio-paste/core/styling-library";
import { copy } from "../../definitions";
import {
  Popover,
  PopoverButton,
  PopoverContainer,
} from "@twilio-paste/core/popover";
import { InformationIcon } from "@twilio-paste/icons/esm/InformationIcon";

const ChatFreeFormQuestionPopoverContainer = styled(PopoverContainer)`
  [data-paste-element="POPOVER_BUTTON"] {
    margin-top: 16px;
  }
`;

const ChatFreeFormQuestionPopover = (): JSX.Element => {
  return (
    <ChatFreeFormQuestionPopoverContainer
      baseId="free-form-question-popover"
      data-testid="free-form-question-popover-container"
      placement="top"
    >
      <PopoverButton
        variant="reset"
        size="reset"
        data-testid="free-form-question-popover-btn"
      >
        <InformationIcon
          decorative={false}
          title="Open Tooltip"
          display="block"
          color="colorTextIcon"
          size="sizeIcon30"
        />
        <Text
          as="span"
          fontSize="fontSize20"
          color="colorTextWeak"
          fontWeight="fontWeightMedium"
        >
          What kind of questions can I ask?
        </Text>
      </PopoverButton>
      <Popover
        aria-label="Popover"
        width="size40"
        data-testid="free-form-question-popover"
      >
        <Text as="p" marginBottom="space30">
          {copy.tooltips.freeFormQuestionText}
        </Text>
        <Box
          data-testid="free-form-question-examples"
          padding="space30"
          backgroundColor="colorBackgroundPrimaryWeakest"
        >
          <Text as="p">{copy.tooltips.freeFormQuestionExamplesIntro}</Text>
          <ol>
            {copy.tooltips.freeFormQuestionExamples.map((example, index) => (
              <li key={index}>{example}</li>
            ))}
          </ol>
        </Box>
      </Popover>
    </ChatFreeFormQuestionPopoverContainer>
  );
};

export default ChatFreeFormQuestionPopover;
